import React from 'react';
import SEOHead from '../components/SEOHead';
import { Car, Calculator, DollarSign, Shield } from 'lucide-react';

const About = () => {
  return (
    <>
      <SEOHead page="about" />
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6">About Car Loan Payment Calculator</h1>
        
        <div className="space-y-8 text-gray-700">
          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <Car className="h-8 w-8 text-blue-600 mr-3" />
              <h2 className="text-2xl font-semibold">Our Mission</h2>
            </div>
            <p className="leading-relaxed">
              Car Loan Payment Calculator is dedicated to providing Australians with accurate, 
              easy-to-use tools for planning vehicle purchases and financing. Our goal is to 
              help you make informed decisions about car loans by providing transparent 
              calculations and educational resources.
            </p>
          </section>

          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <Calculator className="h-8 w-8 text-blue-600 mr-3" />
              <h2 className="text-2xl font-semibold">What We Offer</h2>
            </div>
            <ul className="list-disc list-inside space-y-3">
              <li>Comprehensive car loan payment calculator</li>
              <li>Detailed amortization schedules</li>
              <li>Visual breakdown of interest and principal payments</li>
              <li>Free access with no hidden fees</li>
              <li>User-friendly interface optimized for all devices</li>
            </ul>
          </section>

          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <DollarSign className="h-8 w-8 text-blue-600 mr-3" />
              <h2 className="text-2xl font-semibold">Why Use Our Calculator</h2>
            </div>
            <p className="leading-relaxed mb-4">
              Our car loan calculator is designed with accuracy and simplicity in mind. We provide 
              you with all the information you need to understand the true cost of vehicle financing, 
              helping you to:
            </p>
            <ul className="list-disc list-inside space-y-2">
              <li>Compare different loan terms and interest rates</li>
              <li>Understand how down payments affect your loan</li>
              <li>See the full breakdown of payments over time</li>
              <li>Make informed decisions about your vehicle purchase</li>
            </ul>
          </section>

          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <Shield className="h-8 w-8 text-blue-600 mr-3" />
              <h2 className="text-2xl font-semibold">Who We Serve</h2>
            </div>
            <ul className="list-disc list-inside space-y-3">
              <li>First-time car buyers seeking to understand financing options</li>
              <li>Experienced buyers looking to optimize their car loan terms</li>
              <li>Anyone considering refinancing an existing auto loan</li>
              <li>Budget-conscious consumers comparing vehicle affordability</li>
              <li>Financial planners helping clients with vehicle purchases</li>
            </ul>
          </section>
          
          <div className="bg-blue-50 p-6 rounded-lg border border-blue-100">
            <p className="text-blue-800 italic">
              Note: While our calculator provides accurate estimates based on the information you input, 
              actual loan terms and availability may vary based on your credit score, lender policies, 
              and other factors. We recommend using our calculator as a guide and consulting with financial 
              professionals before making final decisions.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;